import { definitionsSelector } from '@store/selectors/config';
import { socketParamsSelector } from '@store/selectors/user';
import { ofType } from 'redux-observable';
import { EMPTY, Subject, of } from 'rxjs';
import {
  switchMap,
  catchError,
  takeUntil,
  mergeMap,
  pluck,
  skipUntil,
  filter,
  take,
} from 'rxjs/operators';
import { webSocket } from 'rxjs/webSocket';

import { INITIAL_DATA } from '@ezugi/constants';

import { socket } from '../../socket';
import handleErrors from './handleErrors';
import { handleSocketMessage } from './handleSocketMessage';

const openEvents = new Subject();
const closeEvents = new Subject();
const errorEvents = new Subject();

const updateStore = ({ socketMessage, state }) => handleErrors(socketMessage)
  || handleSocketMessage(socketMessage, state)
  || EMPTY;

const socketEpic = (action$, state$) => action$.pipe(
  ofType(socket.request),
  switchMap(() => {
    const url = definitionsSelector(state$.value)?.SERVER_URL_LOBBY;
    const params = socketParamsSelector(state$.value);

    const ws = webSocket({
      url,
      openObserver: openEvents,
      closeObserver: closeEvents,
      errorObserver: errorEvents,
    });

    let errorSub = null;
    let closeSub = null;

    openEvents.subscribe(() => ws.next(params));

    closeSub = closeEvents.subscribe(() => {
      closeSub && closeSub.unsubscribe();
      errorSub && errorSub.unsubscribe();
    });

    errorSub = errorEvents.subscribe(() => {
      closeSub && closeSub.unsubscribe();
      errorSub && errorSub.unsubscribe();
    });

    action$
      .pipe(
        ofType(socket.send),
        pluck('payload'),
        takeUntil(
          action$.pipe(ofType(socket.request, socket.failure, socket.close))
        )
      )
      .subscribe({
        next: (data) => ws.next(data),
      });

    action$
      .pipe(
        ofType(socket.close),
        takeUntil(
          action$.pipe(ofType(socket.request, socket.failure, socket.close))
        )
      )
      .subscribe({
        next: () => ws.complete(),
      });

    return ws.pipe(
      skipUntil(
        ws.pipe(
          filter((socketMessage) => socketMessage?.MessageType === INITIAL_DATA),
          take(1)
        )
      ),
      mergeMap((socketMessage) => updateStore({ socketMessage, state: state$.value })),
      takeUntil(
        action$.pipe(ofType(socket.request, socket.failure, socket.close))
      )
    );
  }),
  catchError((error) => of(socket.failure(error.message)))
);

export default socketEpic;
